import {
	type RefinementListProps,
	useRefinementList,
} from 'react-instantsearch';

import {
	Button,
	Checkbox,
	CheckboxGroup,
} from '~/components/OddscheckerPlus/components/cxy';

export const CheckboxFilter = ({
	isDisabled = false,
	label,
	transformFieldLabels,
	...refinementProps
}: RefinementListProps & {
	isDisabled?: boolean;
	label?: string;
	transformFieldLabels?: (label: string) => JSX.Element | string;
}) => {
	const { canToggleShowMore, isShowingMore, items, refine, toggleShowMore } =
		useRefinementList({
			...refinementProps,
		});

	return (
		<>
			<CheckboxGroup aria-label={label}>
				{items.map(item => {
					return (
						<Checkbox
							checked={item.isRefined}
							disabled={isDisabled}
							key={item.value}
							onCheckedChange={() => refine(item.value)}
							value={item.value}
						>
							{transformFieldLabels
								? transformFieldLabels(item.label)
								: item.label}
						</Checkbox>
					);
				})}
			</CheckboxGroup>
			{canToggleShowMore && (
				<Button onClick={toggleShowMore} variant="ghost">
					{isShowingMore ? 'Show less' : 'Show more'}
				</Button>
			)}
		</>
	);
};
